import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgSuperbarLabel = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 99 22"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="#111">
      <path d="M90.82 7.002c.485-1.623 2.108-2.399 3.634-2.399v4.119c-1.502-.242-3.634.363-3.634 2.762v5.475h-3.634V4.846h3.634zM82.31 4.844h3.634v12.113H82.31v-1.139c-.8.92-1.986 1.478-3.61 1.478-3.173 0-5.79-2.786-5.79-6.396s2.617-6.396 5.79-6.396c1.624 0 2.81.558 3.61 1.478zm-2.883 9.012c1.672 0 2.883-1.139 2.883-2.956S81.1 7.945 79.427 7.945s-2.883 1.138-2.883 2.955 1.212 2.956 2.883 2.956M66.557 4.506c3.174 0 5.79 2.786 5.79 6.396s-2.616 6.396-5.79 6.396c-1.623 0-2.81-.557-3.61-1.478v1.139h-3.634V0h3.634v5.984c.8-.92 1.987-1.478 3.61-1.478m-.727 9.352c1.672 0 2.883-1.139 2.883-2.956s-1.211-2.956-2.883-2.956-2.883 1.139-2.883 2.956 1.212 2.956 2.883 2.956M54.51 7.243c.485-1.623 2.108-2.398 3.635-2.398v4.118c-1.503-.242-3.635.364-3.635 2.762V17.2h-3.633V5.087h3.633zM41.499 12.354c.46 1.26 1.574 1.696 2.907 1.696.993 0 1.841-.388 2.326-.92l2.907 1.67c-1.187 1.648-2.98 2.496-5.282 2.496-4.142 0-6.71-2.786-6.71-6.396s2.616-6.396 6.444-6.396c3.537 0 6.154 2.738 6.154 6.396q0 .763-.146 1.454zm-.073-2.714h5.209c-.388-1.405-1.478-1.913-2.568-1.913-1.381 0-2.302.678-2.641 1.913M31.116 4.504c3.174 0 5.79 2.786 5.79 6.396s-2.616 6.396-5.79 6.396c-1.623 0-2.81-.557-3.61-1.478v5.984h-3.634V4.844h3.634v1.138c.8-.92 1.987-1.478 3.61-1.478m-.727 9.352c1.672 0 2.883-1.139 2.883-2.956s-1.211-2.955-2.883-2.955-2.883 1.138-2.883 2.955 1.211 2.956 2.883 2.956M18.996 4.845h3.634v12.113h-3.634V15.82c-.654.897-1.865 1.478-3.464 1.478-2.447 0-4.53-1.744-4.53-5.015V4.845h3.634v6.904c0 1.502.944 2.205 2.107 2.205 1.333 0 2.253-.775 2.253-2.495zM4.288 8.38c0 1.382 5.96.461 5.96 4.943 0 2.786-2.423 3.973-5.04 3.973-2.422 0-4.263-.92-5.208-2.883l3.15-1.793c.315.921.993 1.43 2.059 1.43.872 0 1.308-.267 1.308-.751 0-1.333-5.96-.63-5.96-4.821 0-2.641 2.23-3.974 4.749-3.974 1.962 0 3.706.873 4.724 2.593L6.929 8.768c-.34-.63-.824-1.066-1.623-1.066-.63 0-1.018.243-1.018.679" />
      <circle cx={95.999} cy={15.142} r={2.12} />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgSuperbarLabel);
const Memo = memo(ForwardRef);
export default Memo;
